import { Component,EventEmitter,OnInit, Output } from '@angular/core';
import { Paging } from '@app/model/paging';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { BusinessPaginData } from '@app/model/business-pagin-data';

@Component({
  selector: 'app-business-list',
  templateUrl: './business-list.component.html',
  styleUrls: ['./business-list.component.css'],
})
export class BusinessListComponent implements OnInit {
  businessList: any;
  filteredBusiness: any[] = [];
  categorys: any;
  currentIndex = -1;
  title = '';
  totalCount: number = 0;
  pagination: number = 1;
  itemsPerPage:number =10;
  searchString: any;
  categoryId:any;

  searchName:any;
  searchCategory:any;

  constructor(
    private route: ActivatedRoute,
    private businessService: BusinessDetailsService) { 
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.searchName = params['name'];
      this.searchCategory = params['id'];

      if(!this.searchName && !this.searchCategory){
        this.getBusinessList(); 
      } else if(this.searchName && !this.searchCategory){
        this.getBusinessListByCategory(this.searchName); 
      } else {
        this.headerSearchByTitle(this.searchName, this.searchCategory)
      }
    });
  }

  @Output() editedEvent = new EventEmitter<Boolean>();
	toggleClass: boolean = false;
  filterEvent(){
    this.toggleClass = !this.toggleClass;    
    this.editedEvent.emit(this.toggleClass);   //this call into parent business.component.ts
  }
    
  //For toggle hide show
	showHideClass: boolean = false;
  clickListEvent(){
      this.showHideClass = !this.showHideClass;       
  }

  getBusinessList() : void {
    let filterObj: Paging = new Paging();
    let businessPagingObj: BusinessPaginData = new BusinessPaginData();
    this.businessService.getAllBusinessInfo(filterObj).subscribe({
      next: (data) => {
        businessPagingObj.BusinessInfo = data as BusinessPaginData ;
        this.businessList = businessPagingObj.BusinessInfo;
        this.filteredBusiness = this.businessList?.data;
        this.totalCount = this.businessList?.data.length;
      } 
    }
  );
  }

  // Category based get business list
  getBusinessListByCategory(categoryName:any) : void {
    let filterObj: Paging = new Paging();
    let businessPagingObj: BusinessPaginData = new BusinessPaginData();
    this.businessService.searchByCategory(categoryName, filterObj).subscribe({
      next: (data) => {
        businessPagingObj.BusinessInfo = data as BusinessPaginData ;
        this.businessList = businessPagingObj.BusinessInfo;
        this.filteredBusiness = this.businessList?.data;
        this.totalCount = this.businessList?.data.length;
      } 
    }
  );
  }

  //Filter product by name / category / country
  async applyFilter(filterCriteria:any): Promise<void> {
    filterCriteria = {
      name: filterCriteria.name,
      category: filterCriteria.category,
      subCategory: filterCriteria.subCategory,
      country: filterCriteria.country,
      state: filterCriteria.state,
      district: filterCriteria.district
    }; 

    if(filterCriteria.name || filterCriteria.category || filterCriteria.country){
      await this.businessListByFilter(filterCriteria);
    } else {
      this.getBusinessList();
      //this.filteredBusiness = this.businessList?.data;
      this.totalCount = this.filteredBusiness.length;
    }
  }

  filterCriteria:any;
  //Search by name for header 
  async headerSearchByTitle(name:any, category:any): Promise<void> {
    this.filterCriteria = {
      name: name,
      category: category,
      subCategory: null,
      country: null,
      state: null,
      district: null
    }; 
    
    if(name || category){
      await this.businessListByFilter(this.filterCriteria);
      // this.businessService.searchBusinessByNameId(name, category, filterObj).subscribe()
    } else {
      this.getBusinessList();
      //this.filteredBusiness = this.businessList?.data;
      this.totalCount = this.filteredBusiness.length;
    }
  }
  
  // Common method for search and filter
  businessListByFilter(filterCriteria:any){
    let filterObj: Paging = new Paging();
      let businessPagingObj: BusinessPaginData = new BusinessPaginData();
      this.businessService.filterBusiness(filterObj, filterCriteria).subscribe({
        next: (data) => {
          businessPagingObj.BusinessInfo = data as BusinessPaginData ;
          this.businessList = businessPagingObj.BusinessInfo;
          if(this.businessList?.data.length > 0){
            this.filteredBusiness = this.businessList?.data;
            this.totalCount = this.businessList?.data.length;
          } else {
            this.filteredBusiness = this.businessList?.data;
            this.totalCount = 0;
          }
          } 
      }
  )}

  sortBy(e:any){
    var order= e.target.value;
    switch (e.target.value) {
      case "asc": {
        this.filteredBusiness.sort((a:any, b:any) => {
          return order === 'asc'
              ? a.businessName.localeCompare(b.businessName)
              : b.businessName.localeCompare(a.businessName);
        });
        break;
      }
      case "desc": {
        this.filteredBusiness.sort((a:any, b:any) => {
          return order === 'desc'
              ? b.businessName.localeCompare(a.businessName)
              : a.businessName.localeCompare(b.businessName);
          });
          break;
      }
      case "category": {
        this.filteredBusiness.sort((a:any, b:any) => {
          return order === 'category'
              ? a.categoryInfoId - b.categoryInfoId 
              : b.categoryInfoId - a.categoryInfoId;
          });
          break;
      }
      case "country": {
      this.filteredBusiness.sort((a:any, b:any) => {
        return order === 'country'
            ? b.countryInfoId - a.countryInfoId 
            : a.countryInfoId - b.countryInfoId;
        });
      }
    }
  }
  
  // Pagination 
  renderPage(event: number) {
    this.pagination = event;
    this.getBusinessList();
    window.scroll(0,0);
  }
 
}
